import styled from "@emotion/styled";

import { BLUE_TEXT_COLOR } from "@/css/constants";

export const ChatContainer = styled("div")<{ height?: number }>`
  height: ${(props) => (props.height ? `${props.height}px` : "auto")};

  .str-chat {
    input[type="file"] {
      display: none;
    }
    max-height: ${(props) => props.height}px;
    min-width: 300px;
  }

  /* Global Stream Chat variables */
  .str-chat {
    --str-chat__typing-indicator-dot-background-color: ${BLUE_TEXT_COLOR};
  }

  str-chat__list,
  .str-chat__message-input {
    position: sticky;
    bottom: 0;
    width: 100%;
    padding: 8px;
    border-top: 1px solid #e2e2e2;
  }

  @media screen and (min-width: 961px) {
    .str-chat__list,
    .str-chat__message-input {
      padding: 16px;
    }
  }

  .str-chat__message-bubble {
    min-height: 28px;
  }

  .str-chat__message-metadata {
    padding: 6px 0px 10px 0px;
  }

  .str-chat__message-reactions-container {
    order: 2; /* Move reactions after the message content */
    align-self: flex-start; /* Align to start of flex container */
    margin-top: 4px; /* Add space between message and reactions */
    margin-bottom: 4px;
  }

  .str-chat__message-input .str-chat__textarea > textarea {
    font-size: 14px;
  }

  .str-chat__typing-indicator {
    background-color: transparent;
    font-size: 10px;
  }

  .str-chat__typing-indicator__dots {
    padding: 0 10px 0 10px;
  }

  .str-chat__message {
    .str-chat__message-inner {
      grid-template-areas:
        "message-bubble options"
        "reactions reactions";
    }
  }

  .str-chat__message.str-chat__message--me .str-chat__message-inner,
  .str-chat__quoted-message-preview.str-chat__message--me
    .str-chat__message-inner {
    grid-template-areas:
      "options message-bubble"
      "reactions reactions";
  }

  .str-chat__message .str-chat__message-sender-avatar,
  .str-chat__quoted-message-preview .str-chat__message-sender-avatar {
    align-self: start;
  }
`;
